'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GroupedSearchButton = require('./components/GroupedSearchButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroupedSearchButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-grouped-search-button/lib/index.js
// module id = 1081
// module chunks = 1